import { Component, OnInit, Input } from '@angular/core';
import { SolutionGroupCell } from '../../types/solution-participation-types';

@Component({
    selector: 'solution-group-cell',
    templateUrl: './solution-group-cell.component.html',
    styleUrls: ['./solution-group-cell.component.scss'],
    standalone: false
})
export class SolutionGroupCellComponent implements OnInit {

  name : string | undefined;
  numOfProducts : string | number | undefined;

  @Input() SGCData : SolutionGroupCell | undefined;

  constructor() {
   }

  ngOnInit(): void {
    this.name = this.SGCData?.name;
    this.numOfProducts = this.SGCData?.numOfProducts;
  }

}
